<template>
  <div class="soundIntroduce" style="position:relative;width:100%;height:100%">
    <!-- AI语音解决方案 -->
    <div class="aiScene">
      <!-- <div class="aiSceneTitle1">应用场景</div> -->
      <!--      <div class="aiSceneTitle">应用场景</div>-->
      <!--      <div style="display:flex">-->
      <!--        <div class="aiSceneContent">-->
      <!-- <div class="aiSceneTopLine"></div>
    <div class="aiSceneSecLine"></div>
    <div class="aiSceneThirdLine"></div>
    <div class="aiSceneFourLine"></div>
      <div class="aiSceneFiveLine"></div>-->
      <!-- <div class="aiSceneText1">
      <div>复诵检查</div>
      <div>跑道入侵预警</div>
      <div>指挥疲劳监测</div>
      <div>冲突指令检查</div>
      <div>危险情况预警</div>
    </div>
    <div class="aiSceneText2">
      <div>管制席题字板</div>
      <div>飞行状态更新</div>
      <div>机组声纹识别</div>
      <div>中英文机组识别</div>
      <div>多席位联合监管</div>
      <div>航班状态统计</div>
    </div>
    <div class="aiSceneText3">
      <div>绩效</div>
      <div>不规范指令用语</div>
    </div>
    <div class="aiSceneText4">
      <div>指挥记录查询</div>
    </div>
    <div class="aiSceneText5">
      <div>管制负荷</div>
      <div>指挥效率分析</div>
      <div>活动时间分析</div>
      <div>管制压力分析</div>
      </div>-->
      <!--          <div class="aiSceneContain">-->
      <!--            <div class="flexStart">-->
      <!--              <div class="aiflexItem aiflexItemimg1">-->
      <!--                <div class="aiBackImg1"></div>-->
      <!--                <div>工作辅助</div>-->
      <!--              </div>-->
      <!--              <div class="aiflexItem aiflexItemimg2">-->
      <!--                <div class="aiBackImg1 aiBackImg2"></div>-->
      <!--                <div>生产安全</div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--            <div class="flexCenter">-->
      <!--              <div class="aiflexItem aiflexItemimg3">-->
      <!--                <div class="aiBackImg1 aiBackImg3"></div>-->
      <!--                <div>效率分析</div>-->
      <!--              </div>-->
      <!--              <div class="aiflexItem aiflexItemimg4">-->
      <!--                <div class="aiBackImg1 aiBackImg4"></div>-->
      <!--                <div>应用场景</div>-->
      <!--              </div>-->
      <!--              <div class="aiflexItem aiflexItemimg5">-->
      <!--                <div class="aiBackImg1 aiBackImg5"></div>-->
      <!--                <div>考核</div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--            <div class="flexEnd">-->
      <!--              <div class="aiflexItem aiflexItemimg6">-->
      <!--                <div class="aiBackImg1 aiBackImg6"></div>-->
      <!--                <div>检索再现</div>-->
      <!--              </div>-->
      <!--              <div class="aiflexItem aiflexItemimg7">-->
      <!--                <div class="aiBackImg1 aiBackImg7"></div>-->
      <!--                <div>培训</div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <div class="aiScene-content">
        <div style="display: flex;justify-content: center;">
          <div class="content-top">
            合规检查/管理
          </div>
        </div>
        <div class="content-info">
          <div>
            <div class="info-bg">
              <div class="info-img">
              </div>
              <div class="info-title">管制品质分析系统</div>
            </div>
            <div class="info-content">
              采集管制现场产生的运行数据，结合管制语音，根据管制通话负荷和运行品质的各项指标定义，运用数据挖掘技术结合管制语音识别技术，为管制工作提供粗细化的评估。
            </div>
          </div>
          <div style="margin-left: 140px">
            <div class="info-bg2">
              <div class="info-img2">
              </div>
              <div class="info-title">机舱语音识别分析平台</div>
            </div>
            <div class="info-content">
              实现有效转录机舱语音、地空通话文本化记录的工具，利用智能化系统和AI代替人工回听和分析，结合QAR和舱音转录结果，将安管、取证和调查分析等业务从按需、人工、滞后，转变为全量、智能、提前。
            </div>
          </div>
          <div style="margin-left: 140px">
            <div class="info-bg3">
              <div class="info-img3">
              </div>
              <div class="info-title">智慧台站</div>
            </div>
            <div class="info-content">
              <p>数据采集</p>
              <p>台站运维管理</p>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!--        <div class="aiSceneContain" style="width:724px">-->
    <!--          <div class="aiSoundbackground"></div>-->
    <!--        </div>-->
  </div>
</template>
<style lang="scss">
.aiScene-content {

  .content-info {
    display: flex;

    .info-content {
      width: 315px;
      font-size: 16px;
      margin-top: 30px;
    }

    .info-title {
      color: #ffffff;
      margin-top: 40px;
      font-size: 20px;
    }

    .info-bg {
      background: url("../assets/gzpz.png") no-repeat;
      height: 360px;
      width: 315px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .info-img {
        width: 92px;
        height: 105px;
        background: url("../assets/gzpz2.png") no-repeat;
      }
    }

    .info-bg2 {
      background: url("../assets/cyyy.png") no-repeat;
      height: 360px;
      width: 315px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;


      .info-img2 {
        width: 92px;
        height: 105px;
        background: url("../assets/gz1.png") no-repeat;
      }
    }
    .info-bg3 {
      background: url("../assets/zhtz.png") no-repeat;
      height: 360px;
      width: 315px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;


      .info-img3 {
        width: 92px;
        height: 105px;
        background: url("../assets/zhtz2.png") no-repeat;
      }
    }
  }

  .content-top {
    width: 165px;
    height: 51px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 2px solid rgb(243, 103, 65);
    font-size: 24px;
    color: rgb(243, 103, 65);
    margin-bottom: 127px;
  }
}

.aiBackImg1 {
  width: 61px;
  height: 60px;
  /* background-color: #ffffff; */
  /* border: solid 1px #c4c5cc; */
  background-image: url("../../../common/commonImages/ai_27.png");
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 8px;
}

.aiBackImg2 {
  width: 56px;
  height: 61px;
  background-image: url("../../../common/commonImages/ai_28.png");
}

.aiBackImg3 {
  width: 60px;
  height: 41px;
  background-image: url("../../../common/commonImages/ai_29.png");
}

.aiBackImg4 {
  width: 70px;
  height: 69px;
  background-image: url("../../../common/commonImages/ai_30.png");
}

.aiBackImg5 {
  width: 61px;
  height: 61px;
  background-image: url("../../../common/commonImages/ai_31.png");
}

.aiBackImg6 {
  width: 63px;
  height: 60px;
  background-image: url("../../../common/commonImages/ai_32.png");
}

.aiBackImg7 {
  width: 80px;
  background-image: url("../../../common/commonImages/ai_25.png");

  height: 50px;
}

.aiSoundbackground {
  /* position: absolute; */
  width: 683px;
  height: 492px;
  /* margin-top: 40px; */
  /* top: 400px;
  left: 709px; */
  /* background-color: #ffffff; */
  /* border: solid 1px #c4c5cc; */
  background-image: url("../../../common/commonImages/ai_7.png");
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.aiSceneText5 {
  color: #646464;
  width: 150px;
  height: 149px;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: column;
  border-right: 5px solid #f0d700;
  position: absolute;
  left: 275px;
  top: 489px;
}

.aiSceneText4 {
  color: #646464;
  width: 150px;
  height: 42px;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: column;
  border-right: 5px solid #f0d700;
  position: absolute;
  top: 372px;
  left: 483px;
}

.aiSceneText3 {
  color: #646464;
  width: 150px;
  height: 66px;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: column;
  border-right: 5px solid #f0d700;
  position: absolute;
  left: 729px;
  top: 308px;
}

.aiSceneText2 {
  color: #646464;
  width: 160px;
  height: 196px;
  display: flex;
  top: 61px;
  left: 616px;
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: column;
  border-right: 5px solid #ee6442;
  position: absolute;
}

.aiSceneText1 {
  color: #646464;
  height: 166px;
  width: 150px;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: column;
  border-right: 5px solid #ee6442;
  position: absolute;
  left: 407px;
  top: 118px;
}

.aiScene {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.aiSceneSecLine {
  width: 636px;
  height: 45px;
  margin-left: 140px;
  background: url("../../../common/commonImages/ai_17.png") no-repeat;
  background-size: 100%;
}

.aiSceneThirdLine {
  width: 558px;
  height: 3px;
  position: absolute;
  top: 307px;
  left: 321px;
  background: url("../../../common/commonImages/ai_20.png") no-repeat;
  background-size: contain;
}

.aiSceneFourLine {
  width: 360px;
  height: 4px;
  position: absolute;
  top: 371px;
  left: 274px;
  background: url("../../../common/commonImages/ai_19.png") no-repeat;
  background-size: contain;
}

.aiSceneFiveLine {
  width: 295px;
  height: 60px;
  position: absolute;
  top: 429px;
  left: 135px;
  background: url("../../../common/commonImages/ai_18.png") no-repeat;
  background-size: contain;
}

.aiSceneTopLine {
  width: 312px;
  height: 25px;
  position: absolute;
  top: 115px;
  left: 245px;
  background: url("../../../common/commonImages/ai_22.png") no-repeat;
  background-size: 100%;
}

.aiSceneContent {
  /* position: relative; */
  width: 510px;
  height: 585px;
}

.aiSceneTitle1 {
  font-size: 40px;
  color: transparent;
  text-align: center;
}

.aiSceneTitle {
  font-size: 40px;
  color: #ff714e;
  text-align: center;
}

.aiflexItem {
  font-size: 18px;
  width: 150px;
  height: 178px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url("../../../common/commonImages/ai_26.png") no-repeat;
  background-size: 100%;
}

.aiflexItemimg1 {
  /* background-image: url("../../../common/commonImages/ai_12.png"); */
}

.aiflexItemimg3 {
  /* background-image: url("../../../common/commonImages/ai_13.png"); */
}

.aiflexItemimg4 {
  background-image: url("");
}

.aiflexItemimg5 {
  /* background-image: url("../../../common/commonImages/ai_16.png"); */
}

.aiflexItemimg6 {
  /* background-image: url("../../../common/commonImages/ai_14.png"); */
}

.aiflexItemimg7 {
  /* background-image: url("../../../common/commonImages/ai_15.png"); */
}

.aiSceneContain {
  width: 515px;
  height: 585px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.flexStart,
.flexCenter,
.flexEnd {
  display: flex;
  margin-bottom: -47px;
}

.soundIntroduce {
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<script>
export default {
  name: "HomeSlide1",
  data() {
    return {};
  },
  created: function () {
  },
  mounted: function () {
  },
  methods: {}
};
</script>
